import { render, staticRenderFns } from "./expenseSingle.vue?vue&type=template&id=1c233a10&scoped=true"
import script from "./expenseSingle.vue?vue&type=script&lang=js"
export * from "./expenseSingle.vue?vue&type=script&lang=js"
import style0 from "./expenseSingle.vue?vue&type=style&index=0&id=1c233a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c233a10",
  null
  
)

export default component.exports